"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.picker.search.mode': '搜索模式',
    'knowledge.picker.search.knowledge': '知识条目',
    'knowledge.picker.search.projects': '项目',
    'knowledge.picker.search.knowledge.label': '搜索知识条目 - 将知识分配给头像',
    'knowledge.picker.search.knowledge.placeholder': '搜索知识条目...',
    'knowledge.picker.search.projects.label': '搜索项目 - 将项目分配给头像',
    'knowledge.picker.search.projects.placeholder': '搜索项目...',
    'knowledge.picker.search.clear': '清除搜索',
    'knowledge.picker.selected.knowledge': '已选择的知识条目',
    'knowledge.picker.selected.projects': '已选择的项目',
    'knowledge.picker.table.name': '名称',
    'knowledge.picker.table.project': '项目',
    'knowledge.picker.table.format': '格式',
    'knowledge.picker.table.size': '大小',
    'knowledge.picker.table.description': '描述',
    'knowledge.picker.remove': '删除',
    'knowledge.picker.confirmRemove': '您确定要删除此知识条目吗？',
    'knowledge.picker.no.results': '未找到任何项目',
    'knowledge.picker.1to1mode': '1:1 模式（完整内容）',
    'knowledge.picker.tooltip': '为AI助手选择文件或添加您自己的文件',
};
